// Explicit user-initiated navigation into the app for an event invite.
// Kept separate from the recovery-navigation module: different contract,
// different credentials, no shared state.
export const openInviteTarget = (url: string): void => {
  window.location.assign(url);
};
